import React, { createContext } from "react";
const ThemeContext = new React.createContext("mado");
export default ThemeContext;